/* eslint func-names: 0 */
import { AppIntegrationsRepository, MeRepository, LicensesRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesProcessor } from 'common/repositoryProcessors/index';

angular.module('controllers').controller(
    'MarketingCard',
    (
        $scope, $state,
        $stateParams, $window, $location,
        Util,
    ) => {

        const queryParams = $location.search();

        $scope.browserName = $window.browserName.toLowerCase();
        $scope.User = MeRepository.getMyUser();
        $scope.screenshotSelected = false;
        $scope.tab = 'screenshots';
        $scope.appId = queryParams.appId || $stateParams.resourceId;
        $scope.bundleAppId = queryParams.bundle;
        $scope.app = AppIntegrationsRepository.getById($scope.appId);
        $scope.deviceData = DevicesProcessor.getAll();
        $scope.isbundleInstalled = queryParams.installed;
        $scope.deviceId = $state.params.resourceId;

        // check if device has prime licence in order to show/not show buy button
        const licsenses = LicensesRepository.getAll();
        $scope.hasPrime = licsenses.find((license) => {

            const appId = license.relationships.app.data.id;
            return appId === 'aps10' || appId === 'aps20' || appId === 'aps30';

        });

        if ($state.current.name.indexOf('.device-details') > -1) {

            $scope.isDeviceDetailsPage = true;

        }

        /**
         * Checks if the app is compatible with the user devices and if it's already installed
         * Returns activate if can be deployed or install if there is no
         * @param {Object} app
         */
        const getButtonLabel = () => {

            // Webapp
            const productUrl = Util.deepFind($scope.app, 'attributes.custom.manifest.product_url');

            if ($scope.bundleAppId) {

                return 'install_bundle';

            }

            if (productUrl) {

                return 'open';

            } else if ($scope.app.devices && $scope.app.devices.length > 0) {

                return 'install_other';

            }

            return 'install';

        };
        $scope.buttonLabel = getButtonLabel();

        $scope.close = (newState) => {

            let currentState;
            if (!newState) {

                currentState = $state.current.name;
                newState = currentState.substr(0, currentState.indexOf('.ltb'));

            }
            $state.go(newState);

        };

        if ($stateParams.modal) {

            $stateParams.modal.result.then(() => {
            }, () => {

                $scope.close();

            });

        }

        $scope.init = () => {

        // redirect to dashboard if the service is not active
            if (!$scope.app) {

                $scope.close();
                return;

            }

            Mixpanel.send('ConnectWeb Marketing Card Open', {
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
                Source: 'Direct',
            });

            $scope.features = $scope.app.attributes.resource.oeFeatures;

        };

        $scope.backScreen = () => {

            $scope.screenshotSelected = false;

        };

        $scope.loadPictures = () => {

            angular.element('.screenshots-cnt img').on('click', function () {

                $scope.screenshotSelected = true;
                if (!angular.element(this).hasClass('big-pic')) {

                    angular.element('.big-pic').remove();
                    angular.element('.screenshots-cnt img').removeClass('selected');
                    angular.element(this).addClass('selected');
                    angular.element('.screenshots-cnt')
                        .append(`<img class="big-pic" src="${this.src}" />`);

                }

            });
            angular.element('.screenshots-cnt img').on('mouseover', function () {

                if ($scope.screenshotSelected === true) {

                    if (!angular.element(this).hasClass('big-pic')) {

                        angular.element('.big-pic').remove();
                        angular.element('.screenshots-cnt img').removeClass('selected');
                        angular.element(this).addClass('selected');
                        angular.element('.screenshots-cnt')
                            .append(`<img class="big-pic" src="${this.src}" />`);

                    }

                }

            });

        };

        /**
        * Show deploy modal.
        *
        * @param {String} serviceId Service id
        */
        $scope.activateService = (serviceId, installType) => {

            const currentDeviceOS = window.deviceOs;

            // check whether we can deploy the product on the current device
            const matchingOS = DevicesProcessor.getDeployOSfor(serviceId, currentDeviceOS) || null;
            const hasMatchingOS = !!matchingOS;

            let stateName = $state.current.name;
            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';

            }

            Mixpanel.send('ConnectWeb Install Click', {
                Page: 'Marketing Card',
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
                'Product ID': serviceId,
            });

            // Fix for device details
            if (stateName.indexOf('.device-details') > -1 && installType === 'install_bundle') {

                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    os: matchingOS,
                    autoInstall: hasMatchingOS,
                    appId: serviceId,
                }, {
                    reload: false,
                });

                return;

            }
            if (stateName.indexOf('.device-details') > -1 && installType === 'install') {

                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    appId: serviceId,
                }, {
                    reload: false,
                });

                return;

            }

            // install on other device
            if (installType === 'other_device') {

                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    resourceId: serviceId,
                    deployType: 'other',
                }, {
                    reload: false,
                });

            } else {

                // normal install
                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    resourceId: serviceId,
                    os: matchingOS,
                    autoInstall: hasMatchingOS,
                }, {
                    reload: false,
                });

            }

        };

        /**
         * Open product link in new tab
         */
        $scope.openServiceLink = (service) => {

            Mixpanel.send('ConnectWeb Open Click', {
                Page: 'Marketing Card',
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
                'Product ID': service.id,
            });

            $window.open(service.attributes.custom.manifest.product_url, '_blank');

        };

        $scope.onTabClick = (tabName) => {

            $scope.tab = tabName;

            Mixpanel.send(`ConnectWeb ${tabName} Click`, {
                Page: 'Marketing Card',
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            });

        };

        /**
         * @param {String} extensionId The extension id for Opera
         * @param {String} appId The app integration id
         */
        $scope.installOperaExtension = (extensionId, appId) => {

            const operaObj = $window.opr || {};

            if (operaObj.addons) {

                operaObj.addons.installExtension(extensionId);

            } else {

                let extensionUrl = CWCONFIG.operaExtensions[appId];
                extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

                $window.open(extensionUrl, '_blank');

            }

        };

        /**
         * @param {Object} app The app integration object
         */
        $scope.sendMixpanelEvent = (app) => {

            Mixpanel.send('ConnectWeb Install Click', {
                Page: 'Marketing Card',
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

        };

        /**
        * Open cart iframe
        *
        * @param {String} appId Service id
        */
        $scope.buy = (appId) => {

            Mixpanel.send('ConnectWeb Buy Click', {
                Page: 'Marketing Card',
                Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
                'Product ID': appId,
            });
            if ($state.current.name.indexOf('.device-details') > -1) {

                $state.go('root.dashboard.device-details.ltb.buy', {
                    ltb: 'payment-cart',
                    appId,
                    subsource: 'card_buy',
                    promotion: true,
                }, {
                    reload: false,
                });

            } else {

                $state.go('root.dashboard.products.ltb.buy', {
                    ltb: 'payment-cart',
                    resourceId: appId,
                    subsource: 'card_buy',
                    promotion: true,
                }, {
                    reload: false,
                });

            }

        };

        $scope.init();

    },
);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/MarketingCard.js